(function () {
  'use strict';

  function getMainVariantId() {
    var section = document.querySelector('.js-complementary-addins');
    var sectionVariantId = section ? section.getAttribute('data-main-variant-id') : null;
    var button = document.querySelector('.js-product-add-to-cart-button');
    var buttonVariantId = button ? button.getAttribute('data-variant-id') : null;
    return buttonVariantId || sectionVariantId || null;
  }

  function getMainQuantity() {
    var input = document.querySelector('.js-quantity-input');
    var qty = input ? parseInt(input.value, 10) : 1;
    return qty > 0 ? qty : 1;
  }

  function getCheckedAddins() {
    var boxes = document.querySelectorAll('.js-complementary-addin:checked');
    return Array.prototype.map.call(boxes, function (box) {
      return { id: parseInt(box.getAttribute('data-variant-id'), 10), quantity: 1 };
    });
  }

  function showError(message) {
    var section = document.querySelector('.js-complementary-addins');
    if (!section) return;
    var container = section.querySelector('.complementary-addins__inner');
    if (!container) return;
    var existing = container.querySelector('.complementary-addins__error');
    if (existing) existing.remove();
    var el = document.createElement('p');
    el.className = 'complementary-addins__error';
    el.textContent = message;
    container.appendChild(el);
  }

  function clearError() {
    var existing = document.querySelector('.complementary-addins__error');
    if (existing) existing.remove();
  }

  function handleClick(event) {
    var button = event.target.closest && event.target.closest('.js-product-add-to-cart-button');
    if (!button) return;

    // Skip buttons that aren't a plain "add to cart": the mobile sticky bar's
    // own Buy Now button goes straight to checkout, and the Selleasy upsell
    // popup button runs its own add-to-cart flow (it carries its own variant
    // data attributes). Neither should be redirected into this bundle flow.
    if (button.getAttribute('data-target') === 'buy-now') return;
    if (button.hasAttribute('data-main-variant-id')) return;

    var addins = getCheckedAddins();
    if (!addins.length) return;

    var mainVariantId = getMainVariantId();
    if (!mainVariantId) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.disabled) return;

    clearError();
    var originalText = button.innerHTML;
    button.disabled = true;

    var items = [{ id: parseInt(mainVariantId, 10), quantity: getMainQuantity() }].concat(addins);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || 'Could not add these items to your cart.');
          });
        }
        return response.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        button.disabled = false;
        button.innerHTML = originalText;
        showError(err.message || 'Something went wrong adding these items. Please try again.');
      });
  }

  document.addEventListener('click', handleClick, true);
})();

/* "Pairs well with" quick view: clicking an add-in's title opens a popup with
   its photos, price, a short description and a "View more details" link. */
(function () {
  'use strict';

  var lastTrigger = null;

  function getModal() {
    var modal = document.querySelector('.js-addin-modal');
    // Move to <body> so position: fixed is not trapped by a transformed ancestor.
    if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
    return modal;
  }

  function open(trigger) {
    var modal = getModal();
    var tpl = document.getElementById(trigger.getAttribute('data-addin-template'));
    if (!modal || !tpl) return;

    var body = modal.querySelector('.js-addin-modal-body');
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    body.scrollTop = 0;

    var more = modal.querySelector('.js-addin-modal-more');
    more.setAttribute('href', tpl.getAttribute('data-url') || '#');

    lastTrigger = trigger;
    modal.hidden = false;
    document.documentElement.classList.add('addin-modal-open');
    modal.querySelector('.addin-modal__close').focus();
  }

  function close() {
    var modal = document.querySelector('.js-addin-modal');
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('addin-modal-open');
    if (lastTrigger) lastTrigger.focus();
    lastTrigger = null;
  }

  function showImage(thumb) {
    var gallery = thumb.closest('.addin-modal__gallery');
    var main = gallery && gallery.querySelector('.js-addin-modal-main');
    if (!main) return;
    main.src = thumb.getAttribute('data-full');
    main.width = +thumb.getAttribute('data-width') || main.width;
    main.height = +thumb.getAttribute('data-height') || main.height;
    gallery.querySelectorAll('.js-addin-modal-thumb').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.js-addin-quickview');
    if (trigger) {
      // Keep the click from reaching the surrounding <label> (which would tick the checkbox).
      e.preventDefault();
      e.stopPropagation();
      open(trigger);
      return;
    }
    if (e.target.closest('[data-addin-close]')) {
      close();
      return;
    }
    var thumb = e.target.closest('.js-addin-modal-thumb');
    if (thumb) showImage(thumb);
  });

  document.addEventListener('keydown', function (e) {
    var modal = document.querySelector('.js-addin-modal');
    if (!modal || modal.hidden) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    // Keep keyboard focus inside the popup.
    var focusable = Array.prototype.filter.call(
      modal.querySelectorAll('a[href], button:not([disabled])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();

/* "Show N more" toggle for add-ins beyond the block's visible count. */
document.addEventListener('click', function (e) {
  var button = e.target.closest && e.target.closest('.js-addins-show-more');
  if (!button) return;
  var root = button.closest('.js-complementary-addins');
  if (!root) return;
  var expanded = button.getAttribute('aria-expanded') === 'true';
  root.querySelectorAll('[data-addin-extra]').forEach(function (row) {
    row.hidden = expanded;
  });
  button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  button.textContent = button.getAttribute(expanded ? 'data-label-more' : 'data-label-less');
});
